import { UserRole } from "tm-shared/types";

const MANAGER_ROLES: UserRole[] = [UserRole.Sv, UserRole.Svm];

export const isManagerRole = (role: UserRole): boolean => {
    if (!role) return false;

    return MANAGER_ROLES.includes(role);
};
